import { Vector2 } from 'app/contracts/Geometry';

/*
 *  Calculate x and y velocity based on cords or mouse position
 * 	https://stackoverflow.com/questions/6417036/track-mouse-speed-with-js
 */

export class Velocity {
	private _now: number;
	private _timestamp: number;
	private _speed: Vector2 = { x: 0, y: 0 };
	private _delta: Vector2 = { x: 0, y: 0 };
	private _lastMouse: Vector2 = { x: 0, y: 0 };
	private _onMouseMove: Function;
	private _onUpdate: Function;
	private _listening: boolean = false;
	private _points: Array<Vector2> = [];

	public set onUpdate(v: Function) {
		this._onUpdate = v;
	}

	public get x(): number {
		return this._speed.x;
	}

	public get y(): number {
		return this._speed.y;
	}

	public set onMouseMove(v: Function) {
		this._onMouseMove = v;
		if (!this._listening) {
			this.listen();
		}
	}

	public listen(): void {
		document.body.addEventListener('mousemove', (e: MouseEvent) => {
			this.calculate({ x: e.clientX, y: e.clientY });
			if (this._onMouseMove) {
				this._onMouseMove(this._speed);
			}
		});
	}

	public getXAvg() {
		let total = 0;
		for (let i = 0; i < this._points.length; i++) {
			total += this._points[i].x;
		}

		return total / this._points.length;
	}

	public calculate(cords: Vector2): Vector2 {
		this._points.push({ x: cords.x - this._lastMouse.x, y: 0 });
		if (this._points.length > 10) {
			this._points.shift();
		}

		if (this._timestamp === null) {
			this._timestamp = Date.now();
			this._lastMouse.x = cords.x;
			this._lastMouse.y = cords.y;
			return;
		}

		this._now = Date.now();
		const dt = this._now - this._timestamp;
		this._delta.x = cords.x - this._lastMouse.x;
		this._delta.y = cords.y - this._lastMouse.y;
		this._speed.x = (this._delta.x / dt) * 100;
		this._speed.y = (this._delta.y / dt) * 100;

		this._timestamp = this._now;
		this._lastMouse.x = cords.x;
		this._lastMouse.y = cords.y;

		if (this._onUpdate) {
			this._onUpdate(this._speed);
		}

		return this._speed;
	}
}
